class DisableSmoothScroll {
  constructor() {
    this.init();
  }

  public get isIE() {
    return !!navigator.userAgent.match(/Trident\/7\./);
  }

  public init() {
    if (this.isIE) {
      document.addEventListener('wheel', (event: WheelEvent) => {
        event.preventDefault();

        window.scrollTo(0, window.pageYOffset + event.deltaY);
      });
    }
  }
}

export default DisableSmoothScroll;
